import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/home-desktop")({
  component: lazyRouteComponent(() => import("./-pages/admin.home-desktop")),
  head: () => ({
    meta: [
      { title: "هوم الديسكتوب — إدارة" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
